import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="contributor-sortable"
export default class extends Controller {
  static values = { 
    url: String
  }
  
  connect() {
    if (typeof Sortable === 'undefined') {
      console.error("SortableJS not loaded!")
      return
    }
    
    this.sortable = Sortable.create(this.element, {
      handle: '.drag-handle',
      animation: 150,
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      onEnd: this.handleReorder.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
      this.sortable = null
    }
  }

  async handleReorder(event) {
    // Only update if the item actually moved to a different position
    if (event.oldIndex === event.newIndex) {
      return
    }

    const contributorId = event.item.dataset.contributorId
    const newPosition = event.newIndex + 1 // acts_as_list is 1-indexed

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken
        },
        body: JSON.stringify({
          contributor_id: contributorId,
          position: newPosition
        })
      })

      if (!response.ok) {
        throw new Error('Failed to update position')
      }

      const data = await response.json()
      
      if (data.success) {
        this.showFlashMessage('Contributor order updated successfully', 'success')
      } else {
        throw new Error(data.message || 'Failed to update position')
      }
    } catch (error) {
      console.error('Error updating contributor position:', error)
      this.showFlashMessage('Failed to update contributor order', 'error')
      // Revert the DOM change
      this.sortable.option("disabled", true)
      location.reload()
    }
  }

  showFlashMessage(message, type) {
    // Try to use existing flash message system if available
    const event = new CustomEvent('flash-message', {
      detail: { message, type }
    })
    window.dispatchEvent(event)
    
    // Fallback to console if no flash system
    console.log(`[${type}] ${message}`)
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }
}
